import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/components/EmptyState';

export const DiaryEmptyDay: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 flex-col py-8">
      <EmptyState label={t('diary.emptyDay')} />
    </div>
  );
};
